import * as React from 'react';
import { Outlet } from 'react-router-dom';

const Team: React.FC = () => {
  return <Outlet />;
};

export default Team;
